import React from "react";

const SavedCardForm = ({ card }) => {
    const maskedCardNumber = cardNumber => {
        const lastFourDigits = cardNumber.substr(-4);
        return "••••  ••••  ••••  " + lastFourDigits;
    };

    return (
        <ol className="alpha">
            {/* Don't give CC inputs names so they won't be submitted to the server */}
            <li>
                <input
                    type="text"
                    id="card-name"
                    value={card.card_name !== null ? card.card_name : ""}
                    placeholder="Name on card"
                    disabled={card}
                    required
                />
                <label htmlFor="card-name" data-label-text="Name on Card">
                    Name on Card
                </label>
            </li>
            <li>
                <input
                    type="text"
                    id="card-number"
                    placeholder="Credit Card Number"
                    value={maskedCardNumber(card.card_number)}
                    disabled={card}
                    required
                />
                <label
                    htmlFor="card-number"
                    data-label-text="Credit Card Number"
                >
                    Credit Card Number
                </label>
                <span id="card-type" />
            </li>
            <li className="half">
                <input
                    type="text"
                    id="card-expiration"
                    placeholder="MM/YY"
                    maxLength="5"
                    value={card.card_expiration}
                    disabled
                    required
                />
                <label
                    htmlFor="card-expiration"
                    data-label-text="Card Expiration"
                >
                    Card Expiration{" "}
                </label>
            </li>
            <li className="half">
                <input
                    type="text"
                    id="card-cvc"
                    placeholder="CVC"
                    maxLength="4"
                    value="•••"
                    disabled
                    required
                />
                <label data-label-text="CVC">CVC</label>
                <a
                    className="ui_information hover-tip hover-tip-info-btn"
                    tabIndex="20"
                >
                    <div className="tooltip tooltip-top tooltip-info-btn">
                        <h3>Find your credit card verification code</h3>
                        <p>
                            The card security code is typically the last three
                            or four digits printed, not embossed like the card
                            number, on the signature strip on the back of the
                            card. American Express codes are generally found on
                            the front side.
                        </p>
                    </div>
                </a>
            </li>
        </ol>
    );
};

export default SavedCardForm;
